import { Injectable } from '@angular/core';

import { NoteType } from '../enums/note.enum';


// @Injectable()
@Injectable({ providedIn: 'root' })
export class ToastService {
	constructor() {}

	/** get note/toast style CSS class */
	getStyle(type: NoteType) {
		switch (type) {
			case NoteType.Error: return 'alert-danger';
			case NoteType.Info: return 'alert-info';
			case NoteType.Success: return 'alert-success';
			case NoteType.Warn: return 'alert-warning';
			default: throw new Error(`getStyle: ${type} is not supported`);
		}
	}
	/** get note/toast icon CSS class */
	getIcon(type: NoteType) {
		switch (type) {
			case NoteType.Error: return 'error';
			case NoteType.Info: return 'information';
			case NoteType.Success: return 'tick-circle';
			case NoteType.Warn: return 'warning';
			default: throw new Error(`getIcon: ${type} is not supported`);
		}
	}
}